import { toast } from "react-toastify";
import { API, get } from "../../../config";

export const getImportLogDetail = async (importLogId, builderId) => {
  try {
    const { data } = await get(
      `${API.PROJECT_IMPORT_LOGS}/` +
        importLogId +
        `${builderId ? "?builder_id=" + builderId : ""}`
    );
    return data.data;
  } catch (e) {
    const errors = e.response?.data?.errors;
    Object.keys(errors).forEach((key) => {
      toast.error(errors[key][0]);
    });
    return null;
  }
};
